var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.notice)?_c('div',[_c('van-notice-bar',{staticStyle:{"height":"35px"},attrs:{"color":"#027AFF","background":"#e6f2ff","left-icon":"volume-o","scrollable":"","text":_vm.notice.title}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }